import styled from 'styled-components';
import {
  backgroundShape,
  borderShape,
  getColor,
  getTextType,
  getSpace,
  mq
} from '@stylesheets/tools';

const StyledTeaser = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${getSpace('l')};

  ${mq('m')} {
    flex-direction: row;
    margin-bottom: ${getSpace('xs')};
  }

  .teaser__meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;
    margin-bottom: ${getSpace('xxs')};
    flex-shrink: 0;
    min-width: 83px;

    ${mq('m')} {
      flex-direction: column;
      justify-content: flex-start;
      padding-top: ${getSpace('s')};
      margin-bottom: 0;
      margin-right: ${getSpace('l')};
    }

    &__time {
      ${getTextType('teaser')};
      min-height: 40px;

      ${mq('m')} {
        margin-bottom: 10px;
      }
    }
    &__bookable {
      position: relative;
      text-align: center;
      font-size: 10px;
      padding: 6px 10px 3px 10px;
      text-transform: uppercase;
      width: min-content;
      height: max-content;
    }
    &__bookable::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }
    &__bookable--filled {
      ${backgroundShape()};
      color: ${getColor('white')};
    }
    &__bookable--bordered {
      ${borderShape()};
    }
  }

  .teaser__image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: auto;
    overflow: hidden;
    margin-bottom: auto;
    max-height: 200px;

    img {
      min-width: 100%;
      min-height: 100%;
    }

    ${mq('m')} {
      padding-right: ${getSpace('m')};
      width: auto;
      max-width: 200px;
      min-width: 200px;
      max-height: 125px;
      height: 100%;
    }
  }

  .teaser__text {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: ${getSpace('m')} auto auto auto;

    ${mq('m')} {
      margin: auto;
    }

    * {
      ${getTextType('subline')};
    }

    h3,
    .teaser__copy p {
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;

      display: none;
      &:nth-of-type(1) {
        display: -webkit-box;
      }
    }

    & > div * {
      ${getTextType('copySmall', 'international')};
      color: ${getColor('teaserGray')} !important;
      margin-left: 0;
      margin-right: 0;
      height: min-content;
    }

    & > div p {
      margin-top: ${getSpace('xs')};
      margin-bottom: ${getSpace('xs')};
    }
  }

  .teaser__book-btn {
    width: min-content;
    white-space: nowrap;
    font-size: 14px;
    border: none;
    margin-top: 0;
    width: calc(100% - 22px);

    ${mq('m')} {
      width: min-content;
      margin: auto;
      margin-left: ${getSpace('xxs')};
    }

    a,
    button {
      width: 100%;
      justify-content: center;
      border-left: unset;

      ${mq('m')} {
        justify-content: flex-start;
        width: min-content;
      }
    }
    a {
      display: block;
    }
  }
`;

export default StyledTeaser;
